import getSessionInfo from './session-Info';

const { brand } = getSessionInfo();

export const brandIds = {
  SETMORE: '110003eb-76c1-4b81-a96a-4cdf91bf70fb',
  TELEPORT: '00937b73-9788-4706-add0-8efdb6aa1684',
  CHATSUPPORT: '9b0cfd9c-0704-4982-bb02-48d3f468f732',
  INCH: 'c5fd52b0-71e6-489f-b044-52390210a437',
  ANYTIME: '0dab9518-34d4-4725-a847-ca7ff65168a2',
  ADAPTIVEU: '73ff763c-32cc-4e25-a4ad-5edbed750f55',
  SERVICEFORGE: 'fb6941af-fb42-42b3-b68c-8512a82743ef',
  ANSWERFORCE: 'c26495e9-f41e-4b8d-a442-22ab742563b7',
  ANSWERFORCE_CA: '014fc01c-2cfb-4a90-a15c-c70c07374cce',
  ANSWERFORCE_UK: 'fd335ead-dac3-4ce1-8908-badaae9c0aa0',
  HELLOSELLS: '12069e64-bd54-4ba9-97f7-249f62cc8178',
  LEXRECEPTION_CA: '5f472e89-7ebd-44a4-9169-82c5428c9549',
  LEXRECEPTION_UK: 'b9a73179-8e11-4022-8684-e5fb220744ca',
  SIGNMORE: 'f6617466-07aa-4ad8-b109-0a8119362962',
  WELLRECEIVED: '9c01c4a2-e055-4342-8589-2e5bd632524c',
  LEXRECEPTION: 'b80d69bd-c236-4aff-82d8-1675f087c8d7',
  SERVICEFORGE_CA: 'd1f07baa-a57c-474b-8577-56502de6d182',
  LISTERPLACE_UK: 'c60997ca-b02b-45be-85a0-1956d92de1e2',
  ANSWERCONNECT_CA: 'a6f26167-e9af-45b3-b73c-f9a9f04658ec',
  ANSWERCONNECT_UK: 'b2f8613c-0d56-40ae-a41d-55aceca62e86',
  ANSWERCONNECT_US: '5a6e67a6-8bfd-45f5-a774-3462cb0c4e4c',
};

export const brandUniqueIdByCategory = {
  SETMORE_PAIDAPPOINTMENTS: `${brandIds.SETMORE}_PaidAppointments`,
  CHATSUPPORT: `${brandIds.CHATSUPPORT}_LiveAnswer`,
  TELEPORT: `${brandIds.TELEPORT}_VideoConferencing`,
  INCH_PAIDAPPOINTMENTS: `${brandIds.INCH}_PaidAppointments`,
  ANYTIME: `${brandIds.ANYTIME}_Anytime`,
  ADAPTIVEU: `${brandIds.ADAPTIVEU}_LMS`,
  SERVICEFORGE_LIVEANSWER: `${brandIds.SERVICEFORGE}_LiveAnswer`,
  ANSWERFORCE_LIVEANSWER: `${brandIds.ANSWERFORCE}_LiveAnswer`,
  ANSWERFORCE_CA_LIVEANSWER: `${brandIds.ANSWERFORCE_CA}_LiveAnswer`,
  ANSWERFORCE_UK_LIVEANSWER: `${brandIds.ANSWERFORCE_UK}_LiveAnswer`,
  ANSWERFORCE_FRANCHISE: `${brandIds.ANSWERFORCE}_FranchisePlans`,
  ANSWERFORCE_CA_FRANCHISE: `${brandIds.ANSWERFORCE_CA}_FranchisePlans`,
  ANSWERFORCE_UK_FRANCHISE: `${brandIds.ANSWERFORCE_UK}_FranchisePlans`,
  HELLOSELLS_LIVEANSWER: `${brandIds.HELLOSELLS}_LiveAnswer`,
  LEXRECEPTION_CA_LIVEANSWER: `${brandIds.LEXRECEPTION_CA}_LiveAnswer`,
  SIGNMORE_LIVEANSWER: `${brandIds.SIGNMORE}_LiveAnswer`,
  WELLRECEIVED_LIVEANSWER: `${brandIds.WELLRECEIVED}_LiveAnswer`,
  LEXRECEPTION_LIVEANSWER: `${brandIds.LEXRECEPTION}_LiveAnswer`,
  LEXRECEPTION_UK_LIVEANSWER: `${brandIds.LEXRECEPTION_UK}_LiveAnswer`,
  SERVICEFORGE_CA_LIVEANSWER: `${brandIds.SERVICEFORGE_CA}_LiveAnswer`,
  LISTERPLACE_UK_ANYWHEREWORKSHUB: `${brandIds.LISTERPLACE_UK}_AnywhereWorksHub`,
  ANSWERCONNECT_CA_LIVEANSWER: `${brandIds.ANSWERCONNECT_CA}_LiveAnswer`,
  ANSWERCONNECT_UK_LIVEANSWER: `${brandIds.ANSWERCONNECT_UK}_LiveAnswer`,
  ANSWERCONNECT_US_LIVEANSWER: `${brandIds.ANSWERCONNECT_US}_LiveAnswer`,
};

export const getBrandInfo = () => brand;

export const isAdaptiveuBrand = brand.id === brandIds.ADAPTIVEU;
export const isAnytimeBrand = brand.id === brandIds.ANYTIME;
export const isINCHBrand = brand.id === brandIds.INCH;
export const isSetmoreBrand = brand.id === brandIds.SETMORE;
export const isTeleportBrand = brand.id === brandIds.TELEPORT;
export const isChatSupportBrand = brand.id === brandIds.CHATSUPPORT;

export const isServiceForgeBrand = brand.id === brandIds.SERVICEFORGE;
export const isAnswerforceBrand = brand.id === brandIds.ANSWERFORCE;
export const isAnswerforceCABrand = brand.id === brandIds.ANSWERFORCE_CA;
export const isAnswerforceUKBrand = brand.id === brandIds.ANSWERFORCE_UK;
export const isHellosellsBrand = brand.id === brandIds.HELLOSELLS;
export const isLexCABrand = brand.id === brandIds.LEXRECEPTION_CA;
export const isSignMoreBrand = brand.id === brandIds.SIGNMORE;
export const isWellReceivedBrand = brand.id === brandIds.WELLRECEIVED;
export const isLexReceptionUSBrand = brand.id === brandIds.LEXRECEPTION;
export const isLexReceptionUKBrand = brand.id === brandIds.LEXRECEPTION_UK;
export const isServiceForgeCABrand = brand.id === brandIds.SERVICEFORGE_CA;
export const isListerPlaceUKBrand = brand.id === brandIds.LISTERPLACE_UK;
export const isAnswerConnectCABrand = brand.id === brandIds.ANSWERCONNECT_CA;
export const isAnswerConnectUKBrand = brand.id === brandIds.ANSWERCONNECT_UK;
export const isAnswerConnectUSBrand = brand.id === brandIds.ANSWERCONNECT_US;

export const isLexReceptionBrand = isLexReceptionUSBrand
                                   || isLexCABrand
                                   || isLexReceptionUKBrand;

export const isAnswerConnectBrand = isAnswerConnectUSBrand
                                    || isAnswerConnectCABrand
                                    || isAnswerConnectUKBrand;

export const isAnsweringServiceBrand = isAnswerforceBrand
                                    || isServiceForgeBrand
                                    || isHellosellsBrand
                                    || isSignMoreBrand
                                    || isLexCABrand
                                    || isWellReceivedBrand
                                    || isLexReceptionUSBrand
                                    || isServiceForgeCABrand
                                    || isLexReceptionUKBrand
                                    || isListerPlaceUKBrand
                                    || isAnswerforceUKBrand
                                    || isAnswerforceCABrand
                                    || isAnswerConnectCABrand
                                    || isAnswerConnectUKBrand
                                    || isAnswerConnectUSBrand;

export const isOnboardingRequired = isAnsweringServiceBrand && !isServiceForgeBrand;

export const isFooterSupported = isHellosellsBrand
                                || isLexCABrand
                                || isSignMoreBrand
                                || isWellReceivedBrand
                                || isChatSupportBrand
                                || isServiceForgeBrand
                                || isServiceForgeCABrand
                                || isListerPlaceUKBrand
                                || isLexReceptionUSBrand
                                || isLexReceptionUKBrand
                                || isAnswerConnectCABrand
                                || isAnswerConnectUKBrand
                                || isAnswerConnectUSBrand;

export const isHostedFieldV1Required = isAdaptiveuBrand
                                    || isHellosellsBrand
                                    || isLexCABrand
                                    || isSignMoreBrand
                                    || isWellReceivedBrand
                                    || isServiceForgeBrand
                                    || isServiceForgeCABrand
                                    || isListerPlaceUKBrand
                                    || isLexReceptionUSBrand
                                    || isLexReceptionUKBrand
                                    || isAnswerConnectCABrand
                                    || isAnswerConnectUKBrand
                                    || isAnswerConnectUSBrand;

export const doesBrandSupportACHPayment = isAnswerforceBrand
                                          || isWellReceivedBrand
                                          || isHellosellsBrand
                                          || isLexReceptionUSBrand
                                          || isAnswerConnectUSBrand
                                          || isSignMoreBrand;

export const brandClassName = brand.name.toLowerCase().trim().split(' ').join('');

export const isCanadaBrand = isLexCABrand
                             || isServiceForgeCABrand
                             || isAnswerforceCABrand
                             || isAnswerConnectCABrand;

export const isUKBrand = isListerPlaceUKBrand
                         || isAnswerforceUKBrand
                         || isLexReceptionUKBrand
                         || isAnswerConnectUKBrand;

export const isTaxApplicable = isCanadaBrand || isUKBrand;

export const v6Supported = brand.id === brandIds.ANYTIME;

export const AWDSupported = isSignMoreBrand
                           || isWellReceivedBrand
                           || isServiceForgeBrand
                           || isServiceForgeCABrand
                           || isListerPlaceUKBrand
                           || isChatSupportBrand
                           || isLexReceptionUKBrand;

export const isSetmoreStartNowPage = () => isSetmoreBrand
                                        && window.location.pathname === '/start-now';

export const isEmailValidityCheckEnabledBrand = isSetmoreBrand;
